import React from 'react';
import { FluidAssetProps } from './types';
import AssetBase from './AssetBase';

/**
 * Fluid asset component that interfaces with the svg sprites
 */
const Fluid = (props: FluidAssetProps) => <AssetBase kind="fluid" {...props} />;

export default React.memo(Fluid);
